/**
 * =============================================================================
 * DELETE RICH MENU TAB IMAGE API SCHEMAS
 * =============================================================================
 *
 * Schemas for the DELETE /richmenus/:id/image endpoint
 * Implements tab-wise image deletion functionality
 */

import { z } from "zod";

/**
 * DELETE /richmenus/:id/image - Path Parameters
 */
export const deleteRichMenuTabImagePathParamsSchema = z.object({
	id: z.coerce
		.number()
		.int()
		.positive()
		.describe("Rich Menu ID for tab-wise image deletion"),
});

/**
 * @description Successfully deleted Rich Menu tab image
 */
export const deleteRichMenuTabImage200Schema = z.object({
	success: z.literal(true),
	message: z.string().describe("Success message"),
	details: z
		.string()
		.optional()
		.describe("Additional details about the deletion"),
	richMenuId: z
		.number()
		.int()
		.describe("ID of the Rich Menu whose image was deleted"),
	deletedImage: z
		.string()
		.optional()
		.describe("Name of the deleted image file"),
});

/**
 * @description Bad request - Invalid Rich Menu ID or no image to delete
 */
export const deleteRichMenuTabImage400Schema = z.object({
	success: z.literal(false),
	message: z.string().describe("Error message"),
	details: z.string().optional().describe("Additional error details"),
});

/**
 * @description Rich Menu not found
 */
export const deleteRichMenuTabImage404Schema = z.object({
	success: z.literal(false),
	message: z.string().describe("Not found message"),
	details: z.string().optional().describe("Additional details"),
});

/**
 * @description Internal server error
 */
export const deleteRichMenuTabImage500Schema = z.object({
	success: z.literal(false),
	message: z.string().describe("Server error message"),
	details: z.string().optional().describe("Error details"),
});

/**
 * Convenience alias for mutation response
 */
export const deleteRichMenuTabImageMutationResponseSchema = z.lazy(
	() => deleteRichMenuTabImage200Schema,
);
